














































import Vue from 'vue';
import firebase from 'firebase/app';
import BbTools from '@/tools/bluebird';
import axios, { AxiosResponse } from 'axios';

require('firebase/firestore');

export default Vue.extend({
  name: 'RapidTestResults',
  data() {
    return {
      rapidTestResults: [],
    };
  },
  async mounted(): Promise<void> {
    if (this.$route.query.fromRapidTest) {
      this.$store.commit('setAlertMessage', {
        text: this.$store.state.tr.TestCompletionMessage,
      });
      this.consumeToken();
    }
    await this.fetchData();
    this.$store.commit('setMainLoading', false);
  },
  methods: {
    async consumeToken(): void {
      const updatedTests = this.$store.state.user.rapidTest - 1 < 0
        ? 0 : this.$store.state.user.rapidTest - 1;
      await firebase.firestore().collection('users')
        .doc(this.$store.state.user.uid).set({
          rapidTest: updatedTests,
        }, { merge: true });
      this.$store.commit('setUser', {
        ...this.$store.state.user,
        rapidTest: updatedTests,
      });
    },
    fetchData() {
      const url = this.$store.getters.URL_RAPID_TEST;
      const params = BbTools.getDefaultParams();
      params.append('_a', 'userResults');
      params.append('fbtoken', this.$store.state.firebaseToken);
      params.append('v2', 'true');
      return axios.post(url, params, BbTools.bbHeaders)
        .then(async (response: AxiosResponse) => {
          const responseJson = response.data;
          if (!responseJson.success || responseJson.error) {
            this.$store.commit('setAlertMessage', {
              text: 'Rapid Test Results error #2',
              error: responseJson.error,
            });
            return;
          }
          this.rapidTestResults = responseJson.data;
        })
        .catch((error) => {
          this.$store.commit('setAlertMessage', {
            text: 'Rapid Test Results error #1',
            error,
          });
        });
    },
    getLangILabel(id: string): string {
      const langI = this.$store.state.langsI
        .find((lang: Lang) => lang.id === id);
      if (langI) return langI.lang;
      return '';
    },
    getLangLLabel(id: string): string {
      const langL = this.$store.state.langsL
        .find((lang: Lang) => lang.id === id);
      if (langL) return langL.lang;
      return '';
    },
    onCertificate(url: string) {
      window.open(url, '_blank');
    },
  },
});
